export const soundCloudMetaData = {
    isRepeatable: false
}
